import styled from 'styled-components';
import { StepPanel, Steps } from '../../../CommonComponents/OPL/Stepper';

export const StyledSteps = styled(Steps)({
  overflowY: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});

export const StyledStepPanel = styled(StepPanel)({
  overflowY: 'hidden',
  display: 'flex',
  flexDirection: 'column',
});
